import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import {
  AppConstant,
  extractAllTwaeLists,
  getCurrentLanguage,
  getCurrentLanguageForWeb,
  JSONConstant,
  translate,
  useAppSelector,
} from '@shalina-app/shared';

import styles from './journey.module.scss';

export const Journey: React.FC<any> = () => {
  const [data, setData] = useState<any>([]);
  const t = translate();
  const lang = useAppSelector(getCurrentLanguageForWeb);

  useEffect(() => {
    const allTimelines = JSONConstant.SOURCE.timelineData as Record<string, any>;
    const primary = (lang ?? 'en').toLowerCase().split(/[-_]/)[0];
    const timelineData = allTimelines[primary] ?? allTimelines.en;

    if (timelineData) {
      const unifiedList = extractAllTwaeLists(timelineData);
      console.log(`Found ${unifiedList.length} total items for ${lang}`);
      setData(unifiedList);
    } else {
      setData([]);
    }
  }, [lang]);

  return (
    <>
      <div className={styles.whoWeAre}>
        <h2 className={styles.title}>{t(AppConstant.ABOUT_US.PG_TWO_TITE_FIRST)}</h2>
        <div className={styles.weAreInfo}>
          <div className={styles.infoText}>
            <p>{t(AppConstant.ABOUT_US.PG_TWO_PARA_FIRST)}</p>
            <p>{t(AppConstant.ABOUT_US.PG_TWO_PARA_TWO)}</p>
            <p>{t(AppConstant.ABOUT_US.PG_TWO_PARA_THREE)}</p>
          </div>
        </div>
      </div>

      <div className={styles.whoWeAre}>
        <h2 className={styles.title}>{t(AppConstant.COMMON.JOURNEY_TAB_TEXT)}</h2>
      </div>

      <div className={styles.journeyWrapper}>
        {data?.map((item: any) => (
          <div key={item?.twae_date_label} className={styles.journeyItem}>
            <div className={styles.date}>{item?.twae_date_label}</div>
            <div className={styles.imgContent}>
              <img src={item?.twae_image.url} className={styles.contentImg} alt="Journey Image" />
              <div className={styles.journeyContent}>{parse(item?.twae_description)}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
